import YFormTable from './Table';

export { YFormTable };
export default YFormTable;
